import { pick, toPairs, filter, compose, equals, head, tail } from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';
import utils from '../../modules/utils';
import XTNA from './XTNA';
import '../app.scss';

export default class XTNAResults extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  render() {
    const results = XTNA.getResults(pick(XTNA.props(), this.props));    
    const derivedProperties = toPairs(results.derivedProperties);
    const filterProps = (type) => filter(compose(equals(type), head, head), derivedProperties);

    return (
      <div style={{ marginBottom: '10px' }}>
        <center>
          <table className='input-table' style={{marginBottom: '20px'}}>
            <thead>
              <tr>
                <td/>
                {filterProps('N').map(compose((prop) => <td key={prop}>{prop}</td>, tail, head))}
              </tr>
            </thead>
            <tbody>
              <tr><td><b>Natural</b></td>{filterProps('N').map(this.renderField)}</tr>
              <tr><td><b>Adaptado</b></td>{filterProps('A').map(this.renderField)}</tr>
            </tbody>
          </table>
        </center>
        <div>
          <div><label>Índice de Consistencia:</label> {utils.formatPercentage(results.consistency)}</div>
          <div><label>Niveles de Cambio:</label> {results.change}</div>
          {this.renderChanges(results.changes)}
          <div><label>Perfil Natural:</label></div>
          <div>{results.NProfile.join(' - ')}</div>
          <div><label>Perfil Adaptado:</label></div>
          <div>{results.AProfile.join(' - ')}</div>
        </div>
      </div>
    );
  }
  renderField(field) {
    return <td key={head(field)}>{tail(field)}</td>;
  }
  renderChanges(changes) {
    return toPairs(changes).map((change) => <div key={tail(head(change))}><label>Cambios en {tail(head(change))}:</label> {tail(change)}</div>)
  }
}



// WEBPACK FOOTER //
// ./src/App/xtna/Results.jsx